export const SEARCH_LENGTH = 70
